import { LuBookOpenText } from 'react-icons/lu'
import { Link } from 'react-router'
import { ROUTES } from '@/constants/routes'
import { bookDidYourMotherTellYou } from '@/assets/siteMedia'

export const BookTeaser = () => (
  <section aria-labelledby="book-heading" className="bg-base-100 py-16 sm:py-20">
    <div className="mx-auto grid max-w-5xl items-center gap-10 px-6 md:grid-cols-[240px_1fr] md:gap-16">
      <img
        src={bookDidYourMotherTellYou}
        alt="Book cover: Did Your Mother Tell You? Celebrating her first period, by Kandake Makonnen. Book One of The Cycle of Womanhood series."
        width={386}
        height={539}
        loading="lazy"
        className="mx-auto w-44 rounded-r-xl shadow-xl sm:w-52"
      />
      <div>
        <h2
          id="book-heading"
          className="font-display text-3xl leading-tight tracking-tight text-base-900 sm:text-4xl"
        >
          The Cycle of Womanhood
        </h2>
        <p className="mt-3 font-display text-xl text-green-800">
          From Menarche to Menopause and Beyond
        </p>
        <p className="mt-5 max-w-lg text-base leading-7 text-base-600">
          A transformational three-volume exploration of women's health, traditional wisdom, herbal
          medicine, the female cycle, menopause, and the sacred journey of womanhood. Blending
          science, storytelling, culture, and lived experience.
        </p>
        <Link
          to={ROUTES.BOOKS}
          className="mt-6 inline-flex min-h-12 items-center justify-center rounded-full border border-green-700 px-6 text-sm font-medium text-green-700 transition-colors hover:bg-green-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700 focus-visible:ring-offset-4"
        >
          Discover the book <LuBookOpenText aria-hidden="true" className="ml-3 h-4 w-4 shrink-0" />
        </Link>
      </div>
    </div>
  </section>
)
